/**
 * Company options for Create Invoice Non PO follow the Switch Company list.
 * Org id and db instance stay on the matching LOV row. Parenthesized names
 * such as "(HAM)" are omitted unless that exact name is in the switch list.
 */
function buildCreateInvoiceCompanyOptions(switchCompanies, lovRows, selectedName) {
  const rows = Array.isArray(lovRows) ? lovRows : [];
  const options = [];

  (switchCompanies || []).forEach((tenant) => {
    const label = tenant && (tenant.tnname || tenant.name);
    if (!label) {
      return;
    }

    const lov = rows.find((row) => row && row.name === label);
    if (lov) {
      options.push(Object.assign({}, lov, { name: label }));
      return;
    }

    options.push({
      name: label,
      db_instance: tenant.db_instance || null,
      value: tenant.value,
    });
  });

  const selected = options.find((option) => option.name === selectedName) || null;
  return { options, selected };
}

module.exports = {
  buildCreateInvoiceCompanyOptions,
};
